// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-detail-tsx": () => import("./../src/templates/detail.tsx" /* webpackChunkName: "component---src-templates-detail-tsx" */),
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-error-tsx": () => import("./../src/pages/error.tsx" /* webpackChunkName: "component---src-pages-error-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

